import Phaser from 'phaser';
export class Load extends Phaser.Scene {
    constructor() {
        super({
            key: 'Load'
        });
    }

    loadFont(name, url) {
        var newFont = new FontFace(name, `url(${url})`);
        newFont.load().then(function (loaded) {
            document.fonts.add(loaded);
        }).catch(function (error) {
            console.error(error);
            return error;
        });
    }

    isSafariNotChromeOrChromium(str) {
        return str.includes('Safari') && !str.includes('Chrome') && !str.includes('Chromium');
    }

    preload() {
        this.loadFont('Truculenta', '/bonez/fonts/Truculenta-Regular.ttf');
        this.loadFont('TruculentaBold', '/bonez/fonts/Truculenta-Black.ttf');

        //Load the full image atlas
        this.load.atlas('all_images', '/bonez/images/image_atlas.webp', '/bonez/images/image_atlas.json');
        this.load.atlas('all_images2', '/bonez/images/image_atlas2.webp', '/bonez/images/image_atlas2.json');
        //Load all the cards atlas
        this.load.atlas('card_images', '/bonez/images/cards_atlas.webp', '/bonez/images/cards_atlas.json');

        this.load.image("PurpleButton", "https://zoombies.world/images/dapp/purple_button_400.webp");
        this.load.image("GreenButton", "https://zoombies.world/images/dapp/green_button_400.webp");

        this.load.image('option1', '/bonez/emojis/default_pack/money.png');
        this.load.image('option2', '/bonez/emojis/neko-kun/neko_kun_angry.png');
        
        //THESE USE setTexture() can't add to atlas
        //this.load.image("BonezIcon", "/bonez/images/bonez_icon.svg"); //used in react, do not delete asset
        //this.load.image("ChipzIcon", "https://zoombies.world/images/bonez/bonez_chipz_credit.webp");
        

        //THESE USE setTexture() leave outside atlas
        // this.load.image("ScoreGreen", "/bonez/images/score_turn_green.svg");
        // this.load.image("ScoreRed", "/bonez/images/score_turn_red.svg");
        // this.load.image("ScorePurple", "/bonez/images/score_turn_purple.svg")

        // this.load.image("CardSlot", "/bonez/images/empty_card_slot.svg");
        // this.load.image("PandaPfp", "/bonez/images/panda_pfp.png");

        //CARD ACCESORIES
        // this.load.image("CardBack", "/bonez/images/cards/back.svg"); //dont change yet
        //needed for card class
        // this.load.image("MinusIcon", "/bonez/images/cards/minus_icon.svg");
        // this.load.image("PlusIcon", "/bonez/images/cards/plus_icon.svg");
        // this.load.image("OneIcon", "/bonez/images/cards/one_icon.svg");
        // this.load.image("ElevenIcon", "/bonez/images/cards/eleven_icon.svg");
        // this.load.image("Times2Icon", "/bonez/images/cards/x2_icon.svg");
        // this.load.image("MinusButton", "/bonez/images/cards/switch_to_neg.svg");
        // this.load.image("PlusButton", "/bonez/images/cards/switch_to_plus.svg");
        // this.load.image("1Or11Button", "/bonez/images/cards/switch_green.svg");

        // this.load.image("ResurrectedBanner", "/bonez/images/cards/resurrected_banner.svg");

        // //HOUSE CARDS
        // this.load.image("1", "/bonez/images/cards/house-cards/1.svg");
        // this.load.image("2", "/bonez/images/cards/house-cards/2.svg");
        // this.load.image("3", "/bonez/images/cards/house-cards/3.svg");
        // this.load.image("4", "/bonez/images/cards/house-cards/4.svg");
        // this.load.image("5", "/bonez/images/cards/house-cards/5.svg");
        // this.load.image("6", "/bonez/images/cards/house-cards/6.svg");
        // this.load.image("7", "/bonez/images/cards/house-cards/7.svg");
        // this.load.image("8", "/bonez/images/cards/house-cards/8.svg");
        // this.load.image("9", "/bonez/images/cards/house-cards/9.svg");
        // this.load.image("10", "/bonez/images/cards/house-cards/10.svg");
        // //HOUSE POWER CARDS
        // this.load.image("neg_1", "/bonez/images/cards/power-cards/neg_1.svg");
        // this.load.image("neg_2", "/bonez/images/cards/power-cards/neg_2.svg");
        // this.load.image("neg_3", "/bonez/images/cards/power-cards/neg_3.svg");
        // this.load.image("neg_4", "/bonez/images/cards/power-cards/neg_4.svg");
        // this.load.image("neg_5", "/bonez/images/cards/power-cards/neg_5.svg");
        // this.load.image("neg_6", "/bonez/images/cards/power-cards/neg_6.svg");
        // this.load.image("plus_1", "/bonez/images/cards/power-cards/plus_1.svg");
        // this.load.image("plus_2", "/bonez/images/cards/power-cards/plus_2.svg");
        // this.load.image("plus_3", "/bonez/images/cards/power-cards/plus_3.svg");
        // this.load.image("plus_4", "/bonez/images/cards/power-cards/plus_4.svg");
        // this.load.image("plus_5", "/bonez/images/cards/power-cards/plus_5.svg");
        // this.load.image("plus_6", "/bonez/images/cards/power-cards/plus_6.svg");
        // this.load.image("plus_neg_1", "/bonez/images/cards/power-cards/plus_neg_1.svg");
        // this.load.image("plus_neg_2", "/bonez/images/cards/power-cards/plus_neg_2.svg");
        // this.load.image("plus_neg_3", "/bonez/images/cards/power-cards/plus_neg_3.svg");
        // this.load.image("plus_neg_4", "/bonez/images/cards/power-cards/plus_neg_4.svg");
        // this.load.image("plus_neg_5", "/bonez/images/cards/power-cards/plus_neg_5.svg");
        // this.load.image("plus_neg_6", "/bonez/images/cards/power-cards/plus_neg_6.svg");
        // //NFT POWER CARDS
        // this.load.image("1_or_11", "/bonez/images/cards/power-cards/1_or_11.svg");
        // this.load.image("double", "/bonez/images/cards/power-cards/double.svg");
        // this.load.image("redraw", "/bonez/images/cards/power-cards/redraw.svg");
        // this.load.image("resurrect", "/bonez/images/cards/power-cards/resurrect.svg");
        // this.load.image("steal", "/bonez/images/cards/power-cards/steal.svg")
        // this.load.image("tie_breaker", "/bonez/images/cards/power-cards/tie_breaker.svg");
      
        // VFX textures
        this.load.spritesheet('vfx-pink-ball', '/bonez/images/sprites/vfx/pipo-nazoobj03a_192.png', { frameWidth: 192, frameHeight: 192 });
        this.load.spritesheet('vfx-green-ball4', '/bonez/images/sprites/vfx/pipo-nazoobj04b_192.png', { frameWidth: 192, frameHeight: 192 });

        //VFX Effects
        this.load.spritesheet('blueFlame_spritesheet', '/bonez/images/sprites/vfx/blue.png', { frameWidth: 100, frameHeight: 100 });        
        this.load.spritesheet('shockwave', '/bonez/images/sprites/vfx/shock-wave.png', { frameWidth: 512, frameHeight: 512, endframe: 16 });
        this.load.spritesheet('firework', '/bonez/images/sprites/vfx/particles-basic.png', { frameWidth: 512, frameHeight: 512, endframe: 16 });
        this.load.spritesheet('white_splash', '/bonez/images/sprites/vfx/impact_hit_sheet.png', { frameWidth: 512, frameHeight: 512, endframe: 16 });
        this.load.spritesheet('white_light_flash', '/bonez/images/sprites/vfx/impact_shine_sheet.png', { frameWidth: 512, frameHeight: 512, endframe: 16 });
        this.load.spritesheet('blue_light_flash', '/bonez/images/sprites/vfx/star_flash_sheet.png', { frameWidth: 512, frameHeight: 512, endframe: 16 });
        this.load.spritesheet('blue_light_burst', '/bonez/images/sprites/vfx/star_bursts_blue_sheet.png', { frameWidth: 512, frameHeight: 512, endframe: 64 });
        this.load.spritesheet('star_burst', '/bonez/images/sprites/vfx/power_burst_star_sheet.png', { frameWidth: 512, frameHeight: 512, endframe: 16 });

        //LEAVE outside atlas
        this.load.image("xp_icon", "/bonez/images/xp.png");
        this.load.image("fire_icon", "/bonez/images/fire_icon.png");

        
        //Wager Type
        this.load.image("zoombies_chipz", "https://zoombies.world/images/bonez/bonez_chipz_credit.webp");
        this.load.image("zoombies_bonez", "/bonez/images/bone.webp");
        
        //Sounds
        this.load.audio('snd_house_power', '/bonez/sounds/play_house_power_bonez_zoombies.mp3');
        this.load.audio('snd_damage', '/bonez/sounds/damage_bonez_zoombies.mp3');
        this.load.audio('snd_draw_card', '/bonez/sounds/draw_house_card_bonez_zoombies.mp3');
        this.load.audio('snd_nft_power', '/bonez/sounds/play_nft_power_bonez_zoombies.mp3');
        this.load.audio('snd_select', '/bonez/sounds/select_bonez_zoombies.mp3');
        this.load.audio('snd_win', '/bonez/sounds/win_bonez_zoombies.mp3');
        this.load.audio('snd_tie', '/bonez/sounds/tie.mp3');
        this.load.audio('opening_music', '/bonez/sounds/music_bonez_zoombies.mp3');
        this.load.audio('theme_music', '/bonez/sounds/bonez_game.mp3');
        this.load.audio('snd_click', '/bonez/sounds/click.mp3' );
        this.load.audio('big_win_sound', '/bonez/sounds/zoombies_big_win.mp3');
        this.load.audio('medium_win_sound', '/bonez/sounds/zoombies_medium_win.mp3');
        this.load.audio('small_win_sound', '/bonez/sounds/zoombies_small_win.mp3');
        this.load.audio('you_lose', '/bonez/sounds/you_lose.mp3');

        //this.load.on("load", (file) => { console.log("Loaded " + file.src) });
    }

    create() {
        this.LOCAL_STORAGE_MUSIC_VOLUME = 'musicVolume';
        this.LOCAL_STORAGE_SOUND_VOLUME = 'soundVolume';

        // fetching values from local storage or use default values
        this.musicVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_MUSIC_VOLUME);
        this.soundVolumeFromStorage = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);

        this.musicVolume = this.musicVolumeFromStorage !== null ? +this.musicVolumeFromStorage / 100 : 12.5 / 100;
        this.soundVolume = this.soundVolumeFromStorage !== null ? +this.soundVolumeFromStorage / 100 : 12.5 / 100;

        this.checkForVolumeChange = () => {
            let newMusicVolume = localStorage.getItem(this.LOCAL_STORAGE_MUSIC_VOLUME);
            let newSoundVolume = localStorage.getItem(this.LOCAL_STORAGE_SOUND_VOLUME);

            newMusicVolume = newMusicVolume !== null ? +newMusicVolume / 100 : 12.5 / 100;
            newSoundVolume = newSoundVolume !== null ? +newSoundVolume / 100 : 12.5 / 100;

            if (this.musicVolume !== newMusicVolume) {
                this.musicVolume = newMusicVolume;
                this.soundInstance.setVolume(this.musicVolume);
            }

            if (this.soundVolume !== newSoundVolume) {
                this.soundVolume = newSoundVolume;
                // this.soundInstance(this.soundVolume);
            }
        }
        
        this.time.addEvent({
            delay: 500,
            callback: this.checkForVolumeChange,
            loop: true
        });

        // fade in the scene
        this.cameras.main.fadeIn(500, 0, 0, 0);
        this.cameras.main.setBackgroundColor('#081733');

        this.soundInstance = this.sound.add('opening_music');
        this.soundInstance.play({ loop: false });
        this.soundInstance.setVolume(this.musicVolume);

        // add the loading logo
        // if(this.isSafariNotChromeOrChromium(navigator.userAgent)){ //Safari
            this.add.sprite(this.sys.game.config.width / 2, this.sys.game.config.height / 2, 'all_images', 'bonez_logo').setScale(3);
        // }else{ //Chrome
        //     this.add.video(this.sys.game.config.width / 2, this.sys.game.config.height / 2, 'video_intro').setScale(0.6).play(false);
        // }

        // add a loading label 
        this.loadLabel = this.add.text(this.sys.game.config.width * 0.5, this.sys.game.config.height * 0.8, 'Prepare to meet your nemesis...',
            { fontFamily: 'TruculentaBold',fontSize: '85px', fill: '#fff' });
        this.loadLabel.setOrigin(0.5, 0.5);

        // fade out after a while
        this.time.addEvent({
            delay: 3900,
            callback: () => { this.cameras.main.fadeOut(500, 0, 0, 0) },
        });

        // once fade out is completed go to main scene
        this.cameras.main.once(Phaser.Cameras.Scene2D.Events.FADE_OUT_COMPLETE, () => {
            this.scene.start('BonezGame');
        })
    }
}